module.exports = __webpack_public_path__ + "img/blog.0af7d569.jpg";